import * as S from './styles'

export const Card = (props) => <S.Card>{props.children}</S.Card>
